export function createPersistedStatePlugin(options = {}) {
    const key = options.key || 'pinia';
    const storage = options.storage || sessionStorage; // Cambiar a sessionStorage
  
    return (context) => {
      const storeKey = `${key}-${context.store.$id}`;
      
      // Cargar el estado inicial desde el almacenamiento
      const savedState = storage.getItem(storeKey);
      if (savedState) {
        context.store.$patch(JSON.parse(savedState));
      }
  
      // Escuchar los cambios en el estado y guardarlos
      context.store.$subscribe((_mutation, state) => {
        storage.setItem(storeKey, JSON.stringify(state));
      });
    };
  }
  